export default __webpack_public_path__ + "static/media/Group 1284@2x.51da0394.png";